import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { Checkbox, Field } from '../../../../../Components/Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Components/Core/InjectedPropsContext';
import { ICoreFieldProps } from '../../../../../Components/Worksheets/Core/Fields/types';
import { valueOrDefault } from '../../../../../Lib/Any';

let HydrometerPortionContainsOversizeParticlesCheckbox: React.FC<ICoreFieldProps> = ({
  createWorksheetSelector,
  visible = true,
  appendNamePrefix = '',
}) => {
  const allowOversizeParticlesEntry: boolean = useSelector(
    pipe(createWorksheetSelector!(`${appendNamePrefix}.AllowContainsOversizeParticlesEntry`), valueOrDefault(true))
  );

  if (!visible) {
    return null;
  }

  return (
    <NamePrefixModifier appendNamePrefix={appendNamePrefix}>
      <Field input={<Checkbox />} name="ContainsOversizeParticles" disabled={!allowOversizeParticlesEntry} />
    </NamePrefixModifier>
  );
};

HydrometerPortionContainsOversizeParticlesCheckbox = withInjectedProps(
  HydrometerPortionContainsOversizeParticlesCheckbox
);

export { HydrometerPortionContainsOversizeParticlesCheckbox };
